import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-black" data-id="element-59">
      <div className="container mx-auto max-w-3xl" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center bg-white/5 p-8 rounded-lg border border-white/10" data-id="element-61">
          <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-8" data-id="element-62">
            <ShieldCheck className="w-24 h-24 text-white" strokeWidth={1} data-id="element-63" />
          </div>
          <div className="text-center md:text-left" data-id="element-64">
            <h3 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-65">
              GARANTÍA DE HIERRO (7 DÍAS)
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-66">
              Probalo 7 días. Si no te aporta claridad real y herramientas
              aplicables... Te devolvemos el dinero.
            </p>
            <p className="font-bold text-white uppercase tracking-wider" data-id="element-67">
              Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}